import { useCallback } from 'react';

import { GridApi } from 'ag-grid-community';

export function useRefocusGrid(gridApi: GridApi | null) {
    return useCallback(() => {
        setTimeout(() => {
            if (!gridApi) return;
            if (document.activeElement?.tagName === 'INPUT') return;

            const firstCol = gridApi.getColumns()?.[0]?.getColId();
            if (!firstCol) return;

            const selectedNode = gridApi.getSelectedNodes()[0];
            const focusedCol =
                gridApi.getFocusedCell()?.column?.getColId() || firstCol;

            if (!selectedNode || selectedNode.rowIndex == null) {
                if (process.env.NODE_ENV === 'development') {
                    console.warn(
                        '[useRefocusGrid] No row selected when attempting to refocus grid. This may indicate state drift.',
                    );
                }
                return;
            }

            const rowIndex = selectedNode.rowIndex;
            gridApi.ensureIndexVisible(rowIndex);
            gridApi.setFocusedCell(rowIndex, focusedCol);
            selectedNode.setSelected(true);
        }, 0);
    }, [gridApi]);
}
